import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
export const selectorRequirementEngagementsSize = (
  requirement: IRequirementResponse
) => {
  return requirement.payerPayeeEngagementIds?.length || 1;
};
